// Module
var code = "<h3>Enlightenment Questions - Question From Bryan</h3> <p>Dear Tathagata,</p> <p>How will I know if I have met a man of truth ?</p> <p>Bryan</p> <p>Answer from Tathagata</p> <p>Dear Bryan,</p> <p>You will know when you confirm what they teach. </p> <p>Tathagata</p> ";
// Exports
module.exports = code;